import { render, staticRenderFns } from "./modalRecebimentoIncidencia.vue?vue&type=template&id=6ae0e25a&"
import script from "./modalRecebimentoIncidencia.vue?vue&type=script&lang=js&"
export * from "./modalRecebimentoIncidencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports